Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "AdminConsole3";
exports.labelBodyText = "AdminConsole3 Body";

exports.btnExampleTitle = "CLICK ME";

exports.usersEndpoint = "account_block/accounts";
exports.permissionsEndpoint = "bx_block_roles_permissions/roles";

exports.packageEndpoint = "bx_block_contentmanagement/package_managements";
// Customizable Area End